import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exportaciones',
  templateUrl: './exportaciones.component.html',
  styleUrls: ['./exportaciones.component.scss']
})
export class ExportacionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
